import { useState } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useNav } from "../nav.tsx";
import { ErrorNote, errText, SectionTitle } from "../ui.tsx";
import { AvatarPicker } from "./AvatarPicker.tsx";
import type { StageProps } from "./EmployeeShell.tsx";

export function AvatarStage({ api, detail, reload }: StageProps) {
  const { go } = useNav();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();
  const e = detail.employee;

  return (
    <div className="grid gap-4">
      <SectionTitle
        title="Avatar"
        description="The employee's face and voice come from one published studio release, pinned by its model hash. Changing it here affects the next release only."
      />
      {e.avatarPin && !detail.state.avatarLive && detail.state.avatarLiveKnown && (
        <Alert variant="warning">
          <AlertTitle>The pinned avatar is no longer published</AlertTitle>
          <AlertDescription>Pick another avatar before publishing. Releases already published keep their pinned model.</AlertDescription>
        </Alert>
      )}
      <ErrorNote error={error} />
      <AvatarPicker
        api={api}
        selectedId={e.avatarPin?.releaseId}
        busy={busy}
        onPick={async (a) => {
          setBusy(true);
          setError(undefined);
          try {
            await api.pinAvatar(e.id, a.id);
            await reload();
            if (!e.jobTitle) go(`/employees/${e.id}/identity`);
          } catch (err) {
            setError(errText(err));
          } finally {
            setBusy(false);
          }
        }}
      />
    </div>
  );
}
